import { AppBar, Button, Toolbar, Typography } from '@mui/material';
import React from 'react';

const Header = (props) => {
    const {openDrawer, handleCreateTenant, } = props;
    const getPathname = window.location.pathname;

    return (
        <>
            <AppBar position="fixed" sx={{ background: 'white', width: openDrawer ? 'calc(100% - 240px)' : 'calc(100% - 72px)', zIndex: (theme) => theme.zIndex.drawer + 1, transition: (theme) => theme.transitions.create(["margin", "width"], { easing: theme.transitions.easing.sharp, duration: theme.transitions.duration.leavingScreen, }),}}>
                    <Toolbar>
                        <Typography variant="h6" sx={{ flexGrow: 1, color: 'black', fontWeight: '700' }}>
                            {getPathname.includes("/courses") ? 'Courses' : 'Customer Manager'}
                        </Typography>
                        <Button color="inherit" onClick={handleCreateTenant} sx={{border: '1px solid', fontWeight: '700', textTransform: 'capitalize', color: '#1976d2', borderColor: '#1976d2'}}>
                            Add New Customer
                        </Button>
                    </Toolbar>
                </AppBar>
        </>
    )
}
export default Header;